import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busserviceforcorporateinpune() {



  const cardData =
  {
    keyword: 'Bus Service for Corporate in Pune ',
    heading: 'Sanavi Travels: Bus Service for Corporate in Pune',
    headingDescription: 'Sanavi Travels provides professional Bus Service for Corporate in Pune, offering safe, punctual, and comfortable transportation solutions for corporate offices, IT parks, industrial units, conferences, meetings, and corporate events. Our fleet of well-maintained AC and Non-AC buses, luxury coaches, and staff transport buses ensures spacious seating, smooth rides, and reliable daily operations. With experienced drivers, flexible monthly and daily corporate bus contracts, GPS-enabled vehicles, transparent pricing, and 24/7 support, our corporate bus services in Pune help companies manage employee and executive transportation efficiently. Choose Sanavi Travels for trusted corporate bus rental services in Pune, delivering reliability, safety, and professionalism for every business journey.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


 "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and a symbol of Maratha glory. Once the seat of Bajirao I’s administration, it features massive stone walls, grand gateways like the Delhi Darwaza, and lush lawns. Although much of it was destroyed in a fire, the remnants still echo royal grandeur. The evening light-and-sound show vividly brings Maratha history to life. Shaniwar Wada stands as Pune’s proud emblem of heritage, valor, and architectural brilliance."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum showcasing Gandhi’s personal artifacts, photographs, and historical documents. The palace’s sprawling gardens, Italian arches, and serene ambiance make it a peaceful retreat. The site also houses the samadhis of Kasturba Gandhi and Mahadev Desai, making it a symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations with music, decorations, and cultural events. The trust behind the temple is also known for extensive charitable work. Devotees find immense peace, blessings, and spiritual solace here. Dagdusheth Ganpati remains the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive up to explore its ancient ramparts, memorials, and scenic viewpoints. The fort offers breathtaking views of the Sahyadri ranges, dotted with lush greenery. Local vendors serve traditional pithla-bhakri meals near the summit. Sinhagad is Pune’s favorite blend of history, adventure, and nature, attracting both historians and thrill-seekers."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi pavilion, and a serene sanctum. Despite being located in a busy urban area, it maintains a tranquil spiritual ambiance. Its ancient carvings showcase the mastery of early Indian craftsmanship. Pataleshwar is Pune’s hidden heritage retreat, offering peace, meditation, and a connection with the city’s ancient past."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. The collection includes traditional ornaments, musical instruments, household antiques, and sculptures. The recreated Mastani Mahal is a major attraction, depicting the lifestyle of historical India. The museum serves as a living archive of art, craftsmanship, and history, making it an invaluable destination for art lovers, students, and tourists seeking cultural insights."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add to its cultural charm. Sunrise and sunset visits are especially mesmerizing. Parvati Hill is Pune’s spiritual and scenic high point, attracting devotees, history enthusiasts, and nature lovers alike."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across beautifully landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation, rejuvenation, and personal transformation. Osho Ashram is Pune’s international retreat for tranquility, blending spiritual learning with holistic wellness practices."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers. Families, joggers, and photography enthusiasts enjoy peaceful walks here. The garden beautifully blends Japanese aesthetics with Indian nature, offering a serene sanctuary within Pune’s urban landscape. It is an ideal spot for relaxation, picnics, and reconnecting with nature."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The vast waterscape and surrounding hills create a picturesque setting, especially during the monsoon season. Street vendors selling roasted corn, tea, and local snacks add to its charm. The dam also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy escape for weekends, sunset views, and family outings, offering both natural beauty and recreational opportunities."
  }
]
,





"services": [
{
"name": "Bus Service for Corporate in Pune",
"description": "Bus Service for Corporate in Pune provides reliable and professional transportation solutions for companies, offices, and business organizations. Designed to meet daily employee commute needs, corporate events, and official travel, these services ensure punctuality, comfort, and safety with well-maintained buses and trained drivers."
},
{
"name": "Corporate Bus Hire Pune",
"description": "Corporate Bus Hire Pune offers flexible bus rental options tailored for corporate requirements such as staff transportation, meetings, conferences, and business tours. With a range of bus sizes and modern facilities, companies can manage group travel efficiently and comfortably."
},
{
"name": "AC Corporate Bus Pune",
"description": "AC Corporate Bus Pune ensures a comfortable and refreshing travel experience for employees and executives. Air-conditioned buses with spacious seating are ideal for long office commutes, corporate outings, and business travel within and outside Pune."
},
{
"name": "Luxury Corporate Bus Rental Pune",
"description": "Luxury Corporate Bus Rental Pune provides premium buses equipped with plush seating, modern interiors, and advanced amenities. Perfect for senior management travel, VIP guests, and high-end corporate events, these buses enhance the professional travel experience."
},
{
"name": "Office Staff Bus Pune",
"description": "Office Staff Bus Pune offers dependable daily transportation for employees commuting to and from the workplace. Scheduled routes, safe driving practices, and comfortable buses help companies ensure smooth and stress-free employee transport."
},
{
"name": "Corporate Event Bus Pune",
"description": "Corporate Event Bus Pune is ideal for transporting employees and guests to conferences, seminars, exhibitions, and corporate functions. These buses ensure timely arrivals, coordinated travel, and a professional experience for all participants."
},
{
"name": "Affordable Corporate Bus Pune",
"description": "Affordable Corporate Bus Pune provides cost-effective transportation solutions without compromising on safety or comfort. Suitable for startups, SMEs, and large organizations, it offers budget-friendly options for regular and occasional corporate travel."
},
{
"name": "Chauffeur Driven Corporate Bus",
"description": "Chauffeur Driven Corporate Bus ensures stress-free travel with experienced and professional drivers handling routes, traffic, and schedules. This service allows companies and employees to focus on work while enjoying a smooth and secure journey."
},
{
"name": "Group Travel Corporate Bus Pune",
"description": "Group Travel Corporate Bus Pune is designed for team outings, training programs, and large staff movements. Spacious buses and organized travel planning make it easy to transport large corporate groups efficiently."
},
{
"name": "Best Corporate Bus Service Pune",
"description": "Best Corporate Bus Service Pune is known for reliability, punctual service, and high-quality buses. Trusted by businesses across Pune, it ensures seamless corporate travel for daily operations and special occasions."
},
{
"name": "Pune Corporate Bus Booking",
"description": "Pune Corporate Bus Booking offers an easy and streamlined process to reserve buses for corporate needs. Flexible scheduling, multiple bus options, and prompt confirmations simplify travel planning for companies."
},
{
"name": "Company Outing Bus Pune",
"description": "Company Outing Bus Pune provides comfortable and enjoyable transportation for team outings, picnics, and offsite events. With safe buses and professional drivers, it helps organizations plan stress-free group activities."
},
{
"name": "Employee Transport Bus Pune",
"description": "Employee Transport Bus Pune specializes in daily staff commute services with fixed routes and schedules. Focused on safety, punctuality, and comfort, it supports efficient workforce mobility for corporate offices."
},
{
"name": "Business Travel Bus Pune",
"description": "Business Travel Bus Pune caters to official travel requirements such as client visits, branch meetings, and intercity corporate travel. Comfortable buses and professional service ensure a productive and relaxed journey."
}
],
"tableData": [
["Bus Service for Corporate in Pune", "Corporate Bus Hire Pune"],
["AC Corporate Bus Pune", "Luxury Corporate Bus Rental Pune"],
["Office Staff Bus Pune", "Corporate Event Bus Pune"],
["Affordable Corporate Bus Pune", "Chauffeur Driven Corporate Bus"],
["Group Travel Corporate Bus Pune", "Best Corporate Bus Service Pune"],
["Pune Corporate Bus Booking", "Company Outing Bus Pune"],
["Employee Transport Bus Pune", "Business Travel Bus Pune"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Corporate Bus Service in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers professional and reliable corporate bus services in Pune, perfect for employee transportation, corporate events, airport transfers, and business tours."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Buses",
    "WhyChoosedescription": "Our fleet includes well-serviced, air-conditioned buses equipped with comfortable seating and modern amenities to ensure a smooth and pleasant ride for your corporate team."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers ensure safe and punctual travel, with experience on Pune city routes and surrounding highways."
  },
  {
    "WhyChooseheading": "Customized Corporate Transport Plans",
    "WhyChoosedescription": "Sanavi Travels offers flexible corporate bus solutions including scheduled pick-ups, drop-offs, and point-to-point services tailored to your company’s needs."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We provide clear and upfront pricing for corporate bus services in Pune, including fuel, tolls, and driver allowances with no hidden fees."
  },
  {
    "WhyChooseheading": "Dedicated Account & 24/7 Customer Support",
    "WhyChoosedescription": "Get dedicated corporate assistance and round-the-clock customer support to manage bookings, cancellations, and on-trip help seamlessly."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip, ensuring a safe and hygienic travel experience for your team."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctuality and dependable service, making Sanavi Travels a trusted choice for corporate bus transportation in Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide corporate bus services in Pune?',
    answer: 'Yes, Sanavi Travels offers professional corporate bus services in Pune for employee commutes, events, tours, and airport transfers.'
  },
  {
    question: 'What types of corporate bus services are available?',
    answer: 'We provide scheduled employee transport, point-to-point services, airport pickups/drop-offs, and customized corporate travel plans.'
  },
  {
    question: 'Can I book a bus for daily employee commute?',
    answer: 'Yes, you can schedule daily buses for employee pick-ups and drop-offs based on your company’s routine.'
  },
  {
    question: 'How can I book the corporate bus service?',
    answer: 'You can book through our website or by contacting our 24x7 customer support team for assistance.'
  },
  {
    question: 'Are the drivers experienced and professional?',
    answer: 'Yes, our drivers are licensed, courteous, professional, and familiar with Pune routes to ensure safe and timely travel.'
  },
  {
    question: 'Is pricing transparent for corporate services?',
    answer: 'Absolutely — Sanavi Travels provides upfront pricing with no hidden charges for corporate bus services in Pune.'
  },
  {
    question: 'Is customer support available during travel?',
    answer: 'Yes, our 24x7 customer support team is available during the journey to help with any queries.'
  },
  {
    question: 'Are the buses cleaned and sanitized regularly?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment methods are accepted?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate invoicing options for your convenience.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Kulkarni',
    feedback: 'Sanavi Travels managed our corporate transport efficiently in Pune — punctual, comfortable, and very professional!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Rina Shah',
    feedback: 'Great corporate bus service for our company events and airport transfers. Seamless and hassle-free experience.',
    rating: 5
  }
];

































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Service for Corporate in Pune - Sanavi Travels",
  "description": "Bus service for corporate travel in Pune by Sanavi Travels for office staff transport, company outings, and corporate events. Choose AC and luxury buses for comfortable, safe, and affordable corporate travel in Pune and nearby locations.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2150"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Bus Service for Corporate in Pune Starting from ₹42 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book buses for corporate travel in Pune with Sanavi Travels. AC and luxury buses for office staff transport, company outings, and corporate events at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/21.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busserviceforcorporateinpune;